import { Button, Dialog } from "@au-schein-de/au-ui-library";
import { Trans, useTranslation } from "react-i18next";

interface ProductDetailsCartItemAddVendorConflictModalProps {
	isOpen: boolean;
	toggleOpen: () => void;
	onConfirm: () => void;
	currentVendorName: string;
}

export const ProductDetailsCartItemAddVendorConflictModal = ({
	isOpen,
	toggleOpen,
	onConfirm,
	currentVendorName,
}: ProductDetailsCartItemAddVendorConflictModalProps) => {
	const { t } = useTranslation(["common", "cart"]);

	return (
		<Dialog.Root open={isOpen} onOpenChange={toggleOpen}>
			<Dialog.Content aria-describedby={undefined} withCloseButton={true}>
				<Dialog.Header>
					<Dialog.Title>
						{t("startNewOrder?.title", { ns: "cart" })}
					</Dialog.Title>

					<Dialog.Description>
						<Trans
							i18nKey="startNewOrder?.description"
							ns="cart"
							values={{
								vendorName: currentVendorName,
							}}
							components={{
								bold: <span className="text-body-bold text-gray-700" />,
							}}
						/>
					</Dialog.Description>
				</Dialog.Header>

				<Dialog.Footer className="flex gap-2" variant="vertical">
					<Button
						size="md"
						variant="primary"
						className="flex flex-grow"
						onClick={onConfirm}
						data-testid="go-to-cart"
					>
						{t("confirm")}
					</Button>
					<Button
						size="md"
						variant="tertiary"
						className="flex flex-grow"
						onClick={toggleOpen}
						data-testid="continue-shopping"
					>
						{t("back")}
					</Button>
				</Dialog.Footer>
			</Dialog.Content>
		</Dialog.Root>
	);
};
